import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

const state = {
  test_count: 0,
  user_connected_id: localStorage.getItem("ct_app_user_connected_id"),
  full_width: false,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}